export const FAKE_BLOCKS1 = [
  {
    file: 'oversecured/ovaa/utils/WeakCrypto.java',
    source_type: 'java',
    lines: [
      {
        line_number: 11,
        is_matched: false,
        content: '    // Great detective work! This is demo code for illustration.',
      },
      {
        line_number: 11,
        is_matched: false,
        content: '    // Contact us to see the full vulnerability report.',
      },
      {
        line_number: 12,
        is_matched: false,
        content: '',
      },
      {
        line_number: 13,
        is_matched: false,
        content: '    public static String encrypt(String data) {',
      },
      {
        line_number: 14,
        is_matched: false,
        content: '        try {',
      },
      {
        line_number: 15,
        is_matched: true,
        content:
          '            SecretKeySpec secretKeySpec = new SecretKeySpec("49u5gh249gh24985ghf429gh4ch8f23f".getBytes(), "AES");',
      },
      {
        line_number: 16,
        is_matched: false,
        content: '            Cipher instance = Cipher.getInstance("AES");',
      },
      {
        line_number: 17,
        is_matched: true,
        content: '            instance.init(1, secretKeySpec);',
      },
      {
        line_number: 18,
        is_matched: false,
        content: '            return Base64.encodeToString(instance.doFinal(data.getBytes()), 0);',
      },
      {
        line_number: 19,
        is_matched: false,
        content: '        } catch (Exception e) {',
      },
      {
        line_number: 20,
        is_matched: false,
        content: '            return "";',
      },
    ],
  },
];

export const FAKE_BLOCKS2 = [
  {
    file: 'oversecured/ovaa/services/DatabaseHelper.java',
    source_type: 'java',
    lines: [
      {
        line_number: 23,
        is_matched: false,
        content: '    // Great detective work! This is demo code for illustration.',
      },
      {
        line_number: 24,
        is_matched: false,
        content: '    // Contact us to see the full vulnerability report.',
      },
      {
        line_number: 25,
        is_matched: false,
        content: '',
      },
      {
        line_number: 26,
        is_matched: false,
        content: '    public boolean authenticateUser(String username, String password) {',
      },
      {
        line_number: 27,
        is_matched: false,
        content: '        String query = "SELECT * FROM users WHERE username = \'"',
      },
      {
        line_number: 28,
        is_matched: true,
        content: '                + username + "\' AND password = \'" + password + "\'";',
      },
      {
        line_number: 29,
        is_matched: false,
        content: '        ResultSet rs = statement.executeQuery(query);',
      },
      {
        line_number: 30,
        is_matched: true,
        content: '        return rs.next();',
      },
      {
        line_number: 31,
        is_matched: false,
        content: '    }',
      },
      {
        line_number: 32,
        is_matched: false,
        content: '',
      },
      {
        line_number: 33,
        is_matched: false,
        content: '    private void logError(String message) {',
      },
    ],
  },
];
